import React, { useEffect, useState } from "react";
import config from "../../config";
import axios from "axios";
import {
  Popconfirm,
  Space,
  Table,
  Pagination,
  Button,
  Tooltip,
  message,
} from "antd";
import { NavLink } from "react-router-dom";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  ExperimentOutlined,
} from "@ant-design/icons";
import LoginChecked from "../Shared/LoginChecked";

function ManageTanks() {
  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");
  const [loading, setLoading] = useState(false);
  const [ListofTanks, SetlistofTanks] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    document.title = "Manage Tank";
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
    };
    var api_config = {
      method: "post",
      url: config.base_url + "Product/GetTanks",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          SetlistofTanks(response.data.ListofTanks);
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
      });
  }, [refreshKey]);

  const columns = [
    {
      title: "ID",
      dataIndex: "ID",
      key: "User ID",
    },
    {
      title: "Tank No",
      dataIndex: "TankNo",
      key: "tankNo",
    },

    {
      title: "Product",
      dataIndex: "ProductID",
      key: "productID",
      render: (_, record) => {
        return record.SelectedProduct.Name;
      },
    },
    {
      title: "Tank Full Capacity",
      dataIndex: "TankFullCapacity",
      key: "balance",
    },

    {
      title: "Useable Capacity",
      dataIndex: "UseableCapacity",
      key: "useableCapacity",
    },
    {
      title: "Tank Shape",
      dataIndex: "TankShape",
      key: "tankShape",
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <NavLink to={`/dipsettings?tank_id=${record.ID}`}>
            <Tooltip title="Add DIP for this tank">
              <ExperimentOutlined />
            </Tooltip>
          </NavLink>
          <NavLink to={`/dipsettings/edit-tank/${record.ID}`}>
            <Tooltip title="Edit">
              <EditOutlined />
            </Tooltip>
          </NavLink>

          <Popconfirm
            title="Delete this tank?"
            description="This cannot be undone."
            onConfirm={() => handelDelete(record.ID)}
          >
            <Tooltip title="Delete">
              <DeleteOutlined />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handelDelete = (ID) => {
    setLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      ID: ID,
    };

    const api_config = {
      method: "post",
      url: config.base_url + "Product/DeleteTank",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code === 1) {
          message.success(response.data.status_message);
          setRefreshKey((k) => k + 1);
        } else {
          message.error(response.data.status_message);
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
      });
  };
  const onPageChange = (page) => {
    setCurrentPage(page);
  };

  const onPageSizeChange = (_current, size) => {
    setCurrentPage(1);
    setPageSize(size);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const ListofTank = ListofTanks.slice(startIndex, endIndex);

  return (
    <>
      <LoginChecked />
      <div className="right-side-contents">
        <div className="page-content">
          <div className="page-header">
            <h6 className="page-title">Manage Tanks</h6>
            <div className="header-actions">
              <NavLink to="/dipsettings/add-tank">
                <Button
                  type="primary"
                  size="large"
                  shape="round"
                  icon={<PlusOutlined style={{ color: "#fff" }} />}
                >
                  Add Tank
                </Button>
              </NavLink>
            </div>
          </div>

          <Table
            size="small"
            rowKey="ID"
            scroll={{
              x: "100%",
            }}
            loading={loading}
            columns={columns}
            dataSource={ListofTank}
            pagination={false}
            bordered
          />
          <div className="text-end mt-5">
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              size="small"
              total={ListofTanks.length}
              onChange={onPageChange}
              onShowSizeChange={onPageSizeChange}
              showSizeChanger
              showQuickJumper
              showTotal={(total) => `Total ${total} items`}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageTanks;
